export { default } from "./ListenToTranslationError";
